import { render, staticRenderFns } from "./permissions-toggle.vue?vue&type=template&id=598c428c&scoped=true&"
import script from "./permissions-toggle.vue?vue&type=script&lang=js&"
export * from "./permissions-toggle.vue?vue&type=script&lang=js&"
import style0 from "./permissions-toggle.vue?vue&type=style&index=0&id=598c428c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598c428c",
  null
  
)

component.options.__file = "permissions-toggle.vue"
export default component.exports